import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import Layout from '../components/Layout'
import globalStyles from '../styles/global.module.css'
import styles from './Login.module.css'

const Login = () => {
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const { login } = useAuth()
  const navigate = useNavigate()

  const handleSubmit = async (e) => {
    e.preventDefault()
    try {
      await login(password)
      navigate('/admin')
    } catch (err) {
      setError('Invalid password')
    }
  }

  return (
    <Layout>
      <div className={`${globalStyles.card} ${styles.loginCard}`}>
        <h2 className={styles.loginTitle}>Admin Login</h2>
        
        {error && <p className={`${globalStyles.error} ${styles.errorMessage}`}>{error}</p>}
        
        <form onSubmit={handleSubmit}>
          <div className={globalStyles.formGroup}>
            <label htmlFor="password">Admin Password</label>
            <input
              id="password"
              type="password"
              className={globalStyles.input}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter admin password"
              required
            />
          </div>
          
          <button type="submit" className={`${globalStyles.button} ${styles.fullWidthButton}`}>
            Login
          </button>
        </form>
      </div>
    </Layout>
  )
}

export default Login 